import {
  EXAM_BLOCK_MODES,
  guideBlockModesForSubject,
  type ExamResourceType,
  type EvaluationBlock,
  type GameMode,
} from '@interactive-room';

const BLOCK_AI_PLACEHOLDERS: Partial<Record<GameMode, string>> = {
  info_block: 'Contexto sobre la Revolución Industrial: causas, fechas clave y actores…',
  completar: 'Oración con hueco sobre el tratado de Versalles, usando vocabulario del info_block…',
  order: 'Ordenar las etapas del proceso de fotosíntesis…',
  vincula: 'Emparejar personajes históricos con sus logros…',
  agrupa: 'Clasificar tipos de energía en renovable / no renovable…',
  desarrollo: 'Consigna de análisis sobre un texto de opinión…',
  sandbox: 'Simulador de factores que llevaron a la crisis de 1929…',
  arena: '3 preguntas de opción múltiple sobre fracciones equivalentes…',
  rhythm_canvas: 'Compás en 4/4 con corcheas y negras para practicar Ta-di…',
  canvas_breakdown: 'Demostración del compás 3 de una pieza estudiada…',
  melody_staff: 'Identificar la nota Sol en pentagrama…',
  ear_training: 'Dictado rítmico con negras y corcheas…',
  symbol_analysis: 'Identificar figuras rítmicas en una secuencia…',
  anatomia: 'Duración de negra, blanca y corchea en 4/4…',
  dictado: 'Transcripción de un patrón rítmico en 3/4…',
  structural_breakdown: 'Desglosar rimas de un poema octava real con badges A/B…',
  source_analysis: 'Analizar una carta histórica con 2-3 preguntas de inferencia…',
};

export function supportsBlockAi(
  mode: GameMode,
  resourceType: ExamResourceType,
  subjectTag?: string,
): boolean {
  const allowed =
    resourceType === 'guide' ? guideBlockModesForSubject(subjectTag) : EXAM_BLOCK_MODES;
  return allowed.includes(mode);
}

export function blockAiPlaceholder(mode: GameMode): string {
  return BLOCK_AI_PLACEHOLDERS[mode] ?? 'Describe el contenido que quieres en este bloque…';
}

export function buildGuideContextFromBlocks(blocks: EvaluationBlock[], blockIndex: number): string {
  const snippets = blocks
    .map((block, index) => {
      if (index === blockIndex || block.mode !== 'info_block') return '';
      const payload = block.payload as { sectionTitle?: string; bodyText?: string; title?: string };
      return [payload.sectionTitle || payload.title, payload.bodyText].filter(Boolean).join('\n');
    })
    .filter(Boolean)
    .slice(0, 4);
  return snippets.join('\n\n');
}
